// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"D_cm","breadcrumbs__link":"D_cn","breadcrumbs__link__active":"D_cp","breadcrumbs__span":"D_cq"};